import {useContext} from "react";
import {CalendarContext} from "../Providers/CalendarContext";
import CalendarType from "../../Models/CalendarType";


const useCalendar = (type: CalendarType) => {
    const calendars: any = useContext(CalendarContext);
    let events;
    if (calendars)
            events = calendars[type];

    return events;
};

export default useCalendar;